var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.dimensions),attrs:{"id":"container"}},[_c('v-app',[_c('v-skeleton-loader',{staticClass:"item",attrs:{"loading":_vm.loading,"type":"card"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }